module.exports = __webpack_public_path__ + "media/public/img/profile-information-preview-281a9cac01b221337264cdc56be51c3c.png";